import { DotsThreeVertical, Key } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import Skeleton from "common/components/ui/Skeleton";

import useMasterApiToken from "../../datahooks/useMasterApiToken";
import useMasterApiTokenMutations from "../../datahooks/useMasterApiTokenMutations";
import ApiTokenTag from "./ApiTokenTag";

export default function MasterApiKey() {
  const { masterApiToken, isLoadingMasterApiToken } = useMasterApiToken();
  const { createMasterApiToken, isCreatingMasterApiToken } =
    useMasterApiTokenMutations();

  return (
    <div className="flex flex-col border-purple-50 bg-purple-50/30 border rounded-3xl">
      <p className="px-3 py-2.5 text-purple-500 text-xs-medium">
        The Master API key is owner exclusive. It can manage all workspaces, and
        is used to set up white label integrations
      </p>
      <div className="flex items-center px-3 py-2.5 gap-x-2.5 rounded-3xl border bg-white border-black-200 -mx-px -mb-px">
        <span className="text-sm-bold flex-1">Master API key</span>
        <span className="text-button-xs flex-1">All</span>
        <div className="flex-1">
          {isLoadingMasterApiToken ? (
            <Skeleton className="w-32 h-6" />
          ) : (
            <ApiTokenTag tokenId={masterApiToken} />
          )}
        </div>
        <span className="flex-1">-</span>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              intent="iconOnly"
              size="sm"
              variant="secondary-black"
              isLoading={isCreatingMasterApiToken}
            >
              <DotsThreeVertical />
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent align="end">
            <DropdownMenuList>
              <DropdownMenuItem onSelect={() => createMasterApiToken()}>
                <Key />
                {masterApiToken ? "Re-generate key" : "Generate key"}
              </DropdownMenuItem>
            </DropdownMenuList>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
